import { useQuery } from '@apollo/react-hooks';
import { removeAccentsAndUpperCase } from '../../common/logics';
import {
  GET_ALL_ENSEIGNES,
  GET_ENSEIGNE,
  GET_MINIMAL_ENSEIGNES,
} from '../../graphql/enseigne/query';
import { useLazyQuery } from '@apollo/react-hooks/lib/useLazyQuery';
import {
  GetEnsigne,
  GetEnsigneVariables,
} from '../../graphql/enseigne/types/GetEnsigne';
import {
  AllEnseignes,
  AllEnseignesVariables,
} from '../../graphql/enseigne/types/AllEnseignes';
import {
  MinimalEnseignes,
  MinimalEnseignesVariables,
} from '../../graphql/enseigne/types/MinimalEnseignes';
import { EnseigneTag } from '../../common/constants';
import { SortOrder } from '../../types/graphql-global-types';

export const useGetAllEnseignes = () => {
  return useQuery<AllEnseignes, AllEnseignesVariables>(GET_ALL_ENSEIGNES, {
    variables: { input: { orderBy: { name: SortOrder.asc } } },
    onError: (error) => console.log(error),
  });
};

export const useMinimalEnseignes = (
  enseigneSearchValue?: string,
  tag?: EnseigneTag,
) => {
  return useQuery<MinimalEnseignes, MinimalEnseignesVariables>(
    GET_MINIMAL_ENSEIGNES,
    {
      variables: {
        input: {
          where: {
            tags: tag ? [tag] : undefined,
            name: enseigneSearchValue
              ? removeAccentsAndUpperCase(enseigneSearchValue)
              : undefined,
          },
          orderBy: { name: SortOrder.asc },
        },
      },
      onError: (error) => {
        if (error.graphQLErrors) {
          if (error.graphQLErrors.length) {
            console.log(
              'autoComplete enseigne error: ',
              error.graphQLErrors[0].message,
            );
          }
        }
      },
      fetchPolicy: 'network-only',
    },
  );
};

export const useGetEnseign = () =>
  useLazyQuery<GetEnsigne, GetEnsigneVariables>(GET_ENSEIGNE, {
    onError: (error) => console.log(error),
  });
